<div class="team-item">
    <div class="avatar-initials-wrapper">
        <sh-avatar-initials [name]="name"></sh-avatar-initials>
    </div>
    <div class="team-item-details">
        <div class="team-item-name" [innerHtml]="name | searchHighlight:searchTerm"></div>
        <div class="team-item-status" [class.signed]="isSigned">{{isSigned ? 'Signed' : 'Sign in'}}</div>
    </div>
</div>